/**
 * Color domain types shared by both apps.
 *
 * Original locations: (identical values, verified):
 *  - web: apps/web/src/pdftron/docManager/differenceColors.ts (ColorId, colorIdToHex)
 *  - api: apps/api/src/utils/differenceColors.ts (ColorId, colorIdToHex)
 */
/** Difference highlight color identifier persisted in the database. */
export var ColorId;
(function (ColorId) {
    ColorId["MULTICOLOR"] = "multicolor";
    ColorId["GREEN"] = "green";
    ColorId["RED"] = "red";
    ColorId["ORANGE"] = "orange";
    ColorId["INDIGO"] = "indigo";
    ColorId["PURPLE"] = "purple";
    ColorId["BLUE"] = "blue";
    ColorId["CYAN"] = "cyan";
    ColorId["SLATE"] = "slate";
    ColorId["PINK"] = "pink";
    ColorId["YELLOW"] = "yellow";
})(ColorId || (ColorId = {}));
/**
 * Hex value for each highlightable {@link ColorId}. `MULTICOLOR` is intentionally
 * absent — it's a sentinel, not a single color.
 */
export const colorIdToHex = {
    [ColorId.GREEN]: '#00FA9A',
    [ColorId.RED]: '#EA3632',
    [ColorId.ORANGE]: '#FF9500',
    [ColorId.INDIGO]: '#6577BA',
    [ColorId.PURPLE]: '#C185FF',
    [ColorId.BLUE]: '#0D96FF',
    [ColorId.CYAN]: '#00BFFF',
    [ColorId.SLATE]: '#A9A9A9',
    [ColorId.PINK]: '#FFA2F7',
    [ColorId.YELLOW]: '#FFFD64',
};
//# sourceMappingURL=color.js.map